var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"90%"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"id":"view"}})],1),_c('GlobalShortcuts'),_c('SystemNotifications'),_c('LoadingOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }